<template>
  <div class="relative rounded-full bg-gray-300 p-1.5">
    <slot />
    <div
      v-if="selected"
      class="absolute -top-1 -right-2 rounded-full bg-white px-0-5"
    >
      <icon-base
        height="16"
        width="16"
        :icon="IconSuccessRoundBig"
        icon-color="#06D6A0"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";

defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
});
</script>
